module.exports = __webpack_public_path__ + "img/Selectold.d7394f2b.svg";